import { useNavigate } from "react-router-dom"

const Footer = () => {
  const navigate = useNavigate();

  const handleNavigate = (url:string) => {
    navigate(url)
  }
  return (
    <div className="main-footer">
      <img src="/assets/logo/logo-blank.png" alt="logo blr" className="logo" />
      <div className="container-right">
        <div className="text" onClick={()=> handleNavigate("/policy")}>Mentions Légales - Politique de confidentialité</div>
        <div className="container-social-network">
          <a href="https://www.facebook.com/profile.php?id=100083342977316" style={{textDecoration:"none"}}>
            <img src="/assets/logo/fb.png" alt="" className="logo-social-network" />
          </a>
          <a href="https://www.instagram.com/leblr77/" style={{textDecoration:"none"}}>
            <img src="/assets/logo/insta.png" alt="" className="logo-social-network" />
          </a>
        </div>
      </div>
    </div>
  )
}

export default Footer